export default __webpack_public_path__ + "static/media/Umeh.e001f6fc.png";